module.exports = __webpack_public_path__ + "static/media/aftermi.82ec284c.gif";